var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['badge', _vm.outcomeClass, 'rounded-pill', 'px-4', 'py-2']},[_vm._v(_vm._s(_vm.outcomeText))])
}
var staticRenderFns = []

export { render, staticRenderFns }